import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=9bf1279a&scoped=true"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsTable.vue?vue&type=style&index=0&id=9bf1279a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf1279a",
  null
  
)

export default component.exports